import Cookie from 'js-cookie'

export default function guest({ next }) {
  const authToken = Cookie.get('_pup_access_token')
  const authUser = Cookie.get('_pup_user')

  if (authToken && authUser) {
    return next({ name: 'Dashboard' })
  } else {
    return next()
  }
}
